import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getListForm } from '../../redux/actions/forms';
import {
  getService,
  createNewService,
  updateStatus,
} from '../../redux/actions/serviceBiller';
import { getListAggregator } from '../../redux/actions/aggregator';

import ServiceCreate from './ServiceCreate.page';

const mapStateToProps = state => ({
  listForm: state.allbiller.listForm,
  listAggregator: state.allbiller.listAggregator,
  service: {},
  loading: state.allbiller.loading,
});

const mapDispatchToProps = {
  getListForm,
  getListAggregator,
  getService,
  createNewService,
  updateStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ServiceCreate));
